/* --------------- open anime --------------- */
$('.lp_2025aw_Bluetab').fadeIn(1000);

/* --------------- scroll anime --------------- */
$(window).on('load scroll', function() {
  $(".js-scroll_anime").each(function() {
    var elemPos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    if (scroll > elemPos - 500) {
      $(this).addClass("is-show");
    }
  });
});

/* --------------- youtube-thumbnail --------------- */
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


function videoControl(action) {
  const playerWindow = $("#player")[0].contentWindow;
  playerWindow.postMessage(
    '{"event":"command","func":"' + action + '","args":""}',
    "*"
  );
}

$('.thumbnail').click(function(){
  $(this).fadeOut(900);
  videoControl("playVideo");
});
